import { render, staticRenderFns } from "./LocalizationDetails.vue?vue&type=template&id=0adb54a0&scoped=true"
import script from "./LocalizationDetails.vue?vue&type=script&lang=js"
export * from "./LocalizationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adb54a0",
  null
  
)

export default component.exports